<template>
  <div id="app">
    <div id="map" class="relative">
      <div class="absolute bottom-0 left-0 bg-white mb-5 ml-5 px-5 py-4 z-50 rounded-xl flex flex-col" style="width:300px">
        <div class="flex flex-row mb-2 ">
          <p class="text-md text-red-700 text-center w-full"><i class="fa fa-warning pr-1"></i> Surface obs are currently static.</p>
        </div>
        <div class="flex flex-row">
          <div class="relative inline-block w-full">
            <div class="w-full">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none" id="options-menu" aria-haspopup="true" aria-expanded="true" v-on:click="toggleSelector">
                <div class="flex-1 text-left">
                  {{ selectedProduct.name }}
                </div>
                <!-- Heroicon name: chevron-down -->
                <svg class="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
              </button>
            </div>

            <transition
              leave-active-class="transition ease-in duration-100"
              leave-class="opacity-100"
              leave-to-class="opacity-0"
            >
              <div class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 w-full z-50" v-if="selectorExpanded">
                <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                  <button class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 w-full text-left" role="menuitem" v-for="product in availableProducts" v-bind:key="product.id" v-on:click="selectProduct(product)">{{ product.name }}</button>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="flex flex-row justify-between items-center mt-4">
          <h2 class="text-lg font-semibold" v-if="radarScans.length !== 0">{{ radarScans[activeIndex].timestamp | formatToLocalTime }}</h2>
          <i class="fas fa-spinner-third fa-spin text-lg" v-if="isLoading"></i>
        </div>
        <div class="flex flex-row pt-3 items-center space-x-4">
          <div>
            <i class="fas fa-play" v-on:click="playRadar()" v-if="!isAnimating"></i>
            <i class="fas fa-pause" v-on:click="pauseRadar()" v-if="isAnimating"></i>
          </div>
          <div class="w-full h-2 bg-gray-400 rounded-full" v-if="radarScans.length !== 0">
            <div class="bg-black h-full rounded-full" :style="{ width: (activeIndex / (radarScans.length - 1)) * 100 + '%' }"></div>
            
            <!-- <div class="TimeLine--timeLineBars--ALnEt" data-children-count="1">
              <div class="TimeLine--historyContainer--8MFjQ">
                <div class="TimeLine--history--3rTCZ" style="width: 24.1758%;"></div>
              </div>
              <label for="timeline-range">Time</label>
              <input id="timeline-range" type="range" min="0" max="9" v-model="activeIndex">
            </div> -->

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as mapboxgl from 'mapbox-gl'
  import moment from 'moment';

  const geojson = require('./components/temp-geojson.json')
  console.log(geojson)
  
  export default {
    name: 'App',
    data() {
      return {
        mapSettings: {
          lon: -96.052335,
          lat: 39.159882,
          zoom: 4.5
        },
        map: null,
        radarScans: [],
        hasInitialLoaded: false,
        activeIndex: null,
        radarInterval: null,
        radarIntervalHangTimeout: null,
        waitingForTilesToLoadInterval: null,
        isAnimating: false,
        isLoading: false,
        firstRunThrough: true,
        selectorExpanded: false,
        availableProducts: [
          {
            id: 1,
            source: 1,
            name: "Radar with Precip Type",
            workspace: "radar",
          }
        ],
        selectedProduct: {
          id: 1,
          source: 1,
          name: "Radar with Precip Type",
          workspace: "radar",
        },
      }
    },
    async mounted() {
      if(this.$route.query.lat) {
        this.mapSettings.lat = this.$route.query.lat
      }
      if(this.$route.query.lon) {
        this.mapSettings.lon = this.$route.query.lon
      }
      if(this.$route.query.z) {
        this.mapSettings.zoom = this.$route.query.z
      } 
      this.getAvailableSources()
      await this.initializeMap()
    },
    methods: {
      async initializeMap() {
        this.map = new mapboxgl.Map({
          container: 'map',
          style: {"version":8,"name":"Dark Matter","metadata":{"mapbox:autocomposite":false,"mapbox:type":"template","mapbox:groups":{"b6371a3f2f5a9932464fa3867530a2e5":{"name":"Transportation","collapsed":false},"a14c9607bc7954ba1df7205bf660433f":{"name":"Boundaries"},"101da9f13b64a08fa4b6ac1168e89e5f":{"name":"Places","collapsed":false}},"openmaptiles:version":"3.x","openmaptiles:mapbox:owner":"openmaptiles","openmaptiles:mapbox:source:url":"mapbox://openmaptiles.4qljc88t"},"sources":{"openmaptiles":{"type":"vector","url":"https://tiles.livestormchasing.com/data/v3.json"}},"sprite":"https://radar-widget.vercel.app/sprite","glyphs":"https://tiles.livestormchasing.com/fonts/{fontstack}/{range}.pbf","layers":[{"id":"background","type":"background","paint":{"background-color":"rgb(12,12,12)"}},{"id":"water","type":"fill","source":"openmaptiles","source-layer":"water","filter":["==","$type","Polygon"],"layout":{"visibility":"visible"},"paint":{"fill-color":"rgb(27 ,27 ,29)","fill-antialias":false}},{"id":"landcover_ice_shelf","type":"fill","source":"openmaptiles","source-layer":"landcover","maxzoom":8,"filter":["all",["==","$type","Polygon"],["==","subclass","ice_shelf"]],"layout":{"visibility":"visible"},"paint":{"fill-color":"rgb(12,12,12)","fill-opacity":0.7}},{"id":"landcover_glacier","type":"fill","source":"openmaptiles","source-layer":"landcover","maxzoom":8,"filter":["all",["==","$type","Polygon"],["==","subclass","glacier"]],"layout":{"visibility":"visible"},"paint":{"fill-color":"hsl(0, 1%, 2%)","fill-opacity":{"base":1,"stops":[[0,1],[8,0.5]]}}},{"id":"landuse_residential","type":"fill","source":"openmaptiles","source-layer":"landuse","maxzoom":9,"filter":["all",["==","$type","Polygon"],["==","class","residential"]],"layout":{"visibility":"visible"},"paint":{"fill-color":"hsl(0, 2%, 5%)","fill-opacity":0.4}},{"id":"landcover_wood","type":"fill","source":"openmaptiles","source-layer":"landcover","minzoom":10,"filter":["all",["==","$type","Polygon"],["==","class","wood"]],"layout":{"visibility":"visible"},"paint":{"fill-color":"rgb(32,32,32)","fill-opacity":{"base":0.3,"stops":[[8,0],[10,0.8],[13,0.4]]},"fill-translate":[0,0],"fill-pattern":"wood-pattern"}},{"id":"landuse_park","type":"fill","source":"openmaptiles","source-layer":"landuse","filter":["all",["==","$type","Polygon"],["==","class","park"]],"layout":{"visibility":"visible"},"paint":{"fill-color":"rgb(32,32,32)"}},{"id":"waterway","type":"line","source":"openmaptiles","source-layer":"waterway","filter":["==","$type","LineString"],"layout":{"visibility":"visible"},"paint":{"line-color":"rgb(27 ,27 ,29)"}},{"id":"water_name","type":"symbol","source":"openmaptiles","source-layer":"water_name","filter":["==","$type","LineString"],"layout":{"text-field":"{name:latin}\n{name:nonlatin}","symbol-placement":"line","text-rotation-alignment":"map","symbol-spacing":500,"text-font":["Metropolis Medium Italic","Noto Sans Italic"],"text-size":12},"paint":{"text-color":"hsla(0, 0%, 0%, 0.7)","text-halo-color":"hsl(0, 0%, 27%)"}},{"id":"building","type":"fill","source":"openmaptiles","source-layer":"building","minzoom":12,"filter":["==","$type","Polygon"],"paint":{"fill-color":"rgb(10,10,10)","fill-outline-color":"rgb(27 ,27 ,29)","fill-antialias":true}},{"id":"aeroway-taxiway","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"aeroway","minzoom":12,"filter":["all",["in","class","taxiway"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#181818","line-width":{"base":1.55,"stops":[[13,1.8],[20,20]]},"line-opacity":1}},{"id":"aeroway-runway-casing","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"aeroway","minzoom":11,"filter":["all",["in","class","runway"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"rgba(60,60,60,0.8)","line-width":{"base":1.5,"stops":[[11,5],[17,55]]},"line-opacity":1}},{"id":"aeroway-area","type":"fill","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"aeroway","minzoom":4,"filter":["all",["==","$type","Polygon"],["in","class","runway","taxiway"]],"layout":{"visibility":"visible"},"paint":{"fill-opacity":1,"fill-color":"#000"}},{"id":"aeroway-runway","type":"line","metadata":{"mapbox:group":"1444849345966.4436"},"source":"openmaptiles","source-layer":"aeroway","minzoom":11,"filter":["all",["in","class","runway"],["==","$type","LineString"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#000","line-width":{"base":1.5,"stops":[[11,4],[17,50]]},"line-opacity":1}},{"id":"highway_path","type":"line","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation","filter":["all",["==","$type","LineString"],["==","class","path"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"rgb(27 ,27 ,29)","line-width":{"base":1.2,"stops":[[13,1],[20,10]]},"line-opacity":0.9,"line-dasharray":[1.5,1.5]}},{"id":"highway_minor","type":"line","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation","minzoom":8,"filter":["all",["==","$type","LineString"],["in","class","minor","service","track"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#181818","line-width":{"base":1.55,"stops":[[13,1.8],[20,20]]},"line-opacity":0.9}},{"id":"highway_major_casing","type":"line","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation","minzoom":11,"filter":["all",["==","$type","LineString"],["in","class","primary","secondary","tertiary","trunk"]],"layout":{"line-cap":"butt","line-join":"miter","visibility":"visible"},"paint":{"line-color":"rgba(60,60,60,0.8)","line-dasharray":[12,0],"line-width":{"base":1.3,"stops":[[10,3],[20,23]]}}},{"id":"highway_major_inner","type":"line","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation","minzoom":11,"filter":["all",["==","$type","LineString"],["in","class","primary","secondary","tertiary","trunk"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"hsl(0, 0%, 7%)","line-width":{"base":1.3,"stops":[[10,2],[20,20]]}}},{"id":"highway_major_subtle","type":"line","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation","minzoom":6,"maxzoom":11,"filter":["all",["==","$type","LineString"],["in","class","primary","secondary","tertiary","trunk"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#2a2a2a","line-width":{"stops":[[6,0],[8,2]]}}},{"id":"highway_motorway_casing","type":"line","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation","minzoom":6,"filter":["all",["==","$type","LineString"],["==","class","motorway"]],"layout":{"line-cap":"butt","line-join":"miter","visibility":"visible"},"paint":{"line-color":"rgba(60,60,60,0.8)","line-width":{"base":1.4,"stops":[[5.8,0],[6,3],[20,40]]},"line-dasharray":[2,0],"line-opacity":1}},{"id":"highway_motorway_inner","type":"line","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation","minzoom":6,"filter":["all",["==","$type","LineString"],["==","class","motorway"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":{"base":1,"stops":[[5.8,"hsla(0, 0%, 85%, 0.53)"],[6,"#000"]]},"line-width":{"base":1.4,"stops":[[4,2],[6,1.3],[20,30]]}}},{"id":"highway_motorway_subtle","type":"line","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation","maxzoom":6,"filter":["all",["==","$type","LineString"],["==","class","motorway"]],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"#181818","line-width":{"base":1.4,"stops":[[4,2],[6,1.3]]}}},{"id":"railway_transit","type":"line","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation","minzoom":16,"filter":["all",["==","$type","LineString"],["all",["==","class","transit"],["!in","brunnel","tunnel"]]],"layout":{"visibility":"visible","line-join":"round"},"paint":{"line-color":"rgb(35,35,35)","line-width":3}},{"id":"railway_transit_dashline","type":"line","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation","minzoom":16,"filter":["all",["==","$type","LineString"],["all",["==","class","transit"],["!in","brunnel","tunnel"]]],"layout":{"visibility":"visible","line-join":"round"},"paint":{"line-color":"rgb(12,12,12)","line-width":2,"line-dasharray":[3,3]}},{"id":"railway_minor","type":"line","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation","minzoom":16,"filter":["all",["==","$type","LineString"],["all",["==","class","rail"],["has","service"]]],"layout":{"visibility":"visible","line-join":"round"},"paint":{"line-color":"rgb(35,35,35)","line-width":3}},{"id":"railway_minor_dashline","type":"line","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation","minzoom":16,"filter":["all",["==","$type","LineString"],["all",["==","class","rail"],["has","service"]]],"layout":{"visibility":"visible","line-join":"round"},"paint":{"line-color":"rgb(12,12,12)","line-width":2,"line-dasharray":[3,3]}},{"id":"railway","type":"line","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation","minzoom":13,"filter":["all",["==","$type","LineString"],["==","class","rail"],["!has","service"]],"layout":{"visibility":"visible","line-join":"round"},"paint":{"line-width":{"base":1.3,"stops":[[16,3],[20,7]]},"line-color":"rgb(35,35,35)"}},{"id":"railway_dashline","type":"line","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation","minzoom":13,"filter":["all",["==","$type","LineString"],["==","class","rail"],["!has","service"]],"layout":{"visibility":"visible","line-join":"round"},"paint":{"line-color":"rgb(12,12,12)","line-width":{"base":1.3,"stops":[[16,2],[20,6]]},"line-dasharray":[3,3]}},{"id":"highway_name_other","type":"symbol","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation_name","filter":["all",["!=","class","motorway"],["==","$type","LineString"]],"layout":{"text-size":10,"text-max-angle":30,"text-transform":"uppercase","symbol-spacing":350,"text-font":["Metropolis Regular","Noto Sans Regular"],"symbol-placement":"line","visibility":"visible","text-rotation-alignment":"map","text-pitch-alignment":"viewport","text-field":"{name:latin} {name:nonlatin}"},"paint":{"text-color":"rgba(80, 78, 78, 1)","text-translate":[0,0],"text-halo-color":"rgba(0, 0, 0, 1)","text-halo-width":1,"text-halo-blur":0}},{"id":"highway_name_motorway","type":"symbol","metadata":{"mapbox:group":"b6371a3f2f5a9932464fa3867530a2e5"},"source":"openmaptiles","source-layer":"transportation_name","filter":["all",["==","$type","LineString"],["==","class","motorway"]],"layout":{"text-size":10,"symbol-spacing":350,"text-font":["Metropolis Light","Noto Sans Regular"],"symbol-placement":"line","visibility":"visible","text-rotation-alignment":"viewport","text-pitch-alignment":"viewport","text-field":"{ref}"},"paint":{"text-color":"hsl(0, 0%, 37%)","text-translate":[0,2]}},{"id":"boundary_state","type":"line","metadata":{"mapbox:group":"a14c9607bc7954ba1df7205bf660433f"},"source":"openmaptiles","source-layer":"boundary","filter":["==","admin_level",4],"layout":{"line-cap":"round","line-join":"round","visibility":"visible"},"paint":{"line-color":"hsl(0, 0%, 21%)","line-width":{"base":1.3,"stops":[[3,1],[22,15]]},"line-blur":0.4,"line-dasharray":[2,2],"line-opacity":1}},{"id":"boundary_country","type":"line","metadata":{"mapbox:group":"a14c9607bc7954ba1df7205bf660433f"},"source":"openmaptiles","source-layer":"boundary","filter":["==","admin_level",2],"layout":{"line-cap":"round","line-join":"round"},"paint":{"line-color":"hsl(0, 0%, 23%)","line-width":{"base":1.1,"stops":[[3,1],[22,20]]},"line-blur":{"base":1,"stops":[[0,0.4],[22,4]]},"line-opacity":1}},{"id":"place_other","type":"symbol","metadata":{"mapbox:group":"101da9f13b64a08fa4b6ac1168e89e5f"},"source":"openmaptiles","source-layer":"place","maxzoom":14,"filter":["all",["==","$type","Point"],["in","class","hamlet","isolated_dwelling","neighbourhood"]],"layout":{"text-size":10,"text-transform":"uppercase","text-font":["Metropolis Regular","Noto Sans Regular"],"text-justify":"center","visibility":"visible","text-offset":[0.5,0],"text-anchor":"center","text-field":"{name:latin}\n{name:nonlatin}"},"paint":{"text-color":"rgb(101,101,101)","text-halo-color":"rgba(0,0,0,0.7)","text-halo-width":1,"text-halo-blur":1}},{"id":"place_suburb","type":"symbol","metadata":{"mapbox:group":"101da9f13b64a08fa4b6ac1168e89e5f"},"source":"openmaptiles","source-layer":"place","maxzoom":15,"filter":["all",["==","$type","Point"],["==","class","suburb"]],"layout":{"text-size":10,"text-transform":"uppercase","text-font":["Metropolis Regular","Noto Sans Regular"],"text-justify":"center","visibility":"visible","text-offset":[0.5,0],"text-anchor":"center","text-field":"{name:latin}\n{name:nonlatin}"},"paint":{"text-color":"rgb(101,101,101)","text-halo-color":"rgba(0,0,0,0.7)","text-halo-width":1,"text-halo-blur":1}},{"id":"place_village","type":"symbol","metadata":{"mapbox:group":"101da9f13b64a08fa4b6ac1168e89e5f"},"source":"openmaptiles","source-layer":"place","maxzoom":14,"filter":["all",["==","$type","Point"],["==","class","village"]],"layout":{"text-size":10,"text-transform":"uppercase","text-font":["Metropolis Regular","Noto Sans Regular"],"text-justify":"left","visibility":"visible","text-offset":[0.5,0.2],"icon-size":0.4,"text-anchor":"left","text-field":"{name:latin}\n{name:nonlatin}"},"paint":{"text-color":"rgb(101,101,101)","text-halo-color":"rgba(0,0,0,0.7)","text-halo-width":1,"text-halo-blur":1,"icon-opacity":0.7}},{"id":"place_town","type":"symbol","metadata":{"mapbox:group":"101da9f13b64a08fa4b6ac1168e89e5f"},"source":"openmaptiles","source-layer":"place","maxzoom":15,"filter":["all",["==","$type","Point"],["==","class","town"]],"layout":{"text-size":10,"icon-image":{"base":1,"stops":[[0,"circle-11"],[9,""]]},"text-transform":"uppercase","text-font":["Metropolis Regular","Noto Sans Regular"],"text-justify":"left","visibility":"visible","text-offset":[0.5,0.2],"icon-size":0.4,"text-anchor":{"base":1,"stops":[[0,"left"],[8,"center"]]},"text-field":"{name:latin}\n{name:nonlatin}"},"paint":{"text-color":"rgb(101,101,101)","text-halo-color":"rgba(0,0,0,0.7)","text-halo-width":1,"text-halo-blur":1,"icon-opacity":0.7}},{"id":"place_city","type":"symbol","metadata":{"mapbox:group":"101da9f13b64a08fa4b6ac1168e89e5f"},"source":"openmaptiles","source-layer":"place","maxzoom":14,"filter":["all",["==","$type","Point"],["==","class","city"],[">","rank",3]],"layout":{"text-size":10,"icon-image":{"base":1,"stops":[[0,"circle-11"],[9,""]]},"text-transform":"uppercase","text-font":["Metropolis Regular","Noto Sans Regular"],"text-justify":"left","visibility":"visible","text-offset":[0.5,0.2],"icon-size":0.4,"text-anchor":{"base":1,"stops":[[0,"left"],[8,"center"]]},"text-field":"{name:latin}\n{name:nonlatin}"},"paint":{"text-color":"rgb(101,101,101)","text-halo-color":"rgba(0,0,0,0.7)","text-halo-width":1,"text-halo-blur":1,"icon-opacity":0.7}},{"id":"place_city_large","type":"symbol","metadata":{"mapbox:group":"101da9f13b64a08fa4b6ac1168e89e5f"},"source":"openmaptiles","source-layer":"place","maxzoom":12,"filter":["all",["==","$type","Point"],["<=","rank",3],["==","class","city"]],"layout":{"text-size":14,"icon-image":{"base":1,"stops":[[0,"circle-11"],[9,""]]},"text-transform":"uppercase","text-font":["Metropolis Regular","Noto Sans Regular"],"text-justify":"left","visibility":"visible","text-offset":[0.5,0.2],"icon-size":0.4,"text-anchor":{"base":1,"stops":[[0,"left"],[8,"center"]]},"text-field":"{name:latin}\n{name:nonlatin}"},"paint":{"text-color":"rgb(101,101,101)","text-halo-color":"rgba(0,0,0,0.7)","text-halo-width":1,"text-halo-blur":1,"icon-opacity":0.7}},{"id":"place_state","type":"symbol","metadata":{"mapbox:group":"101da9f13b64a08fa4b6ac1168e89e5f"},"source":"openmaptiles","source-layer":"place","maxzoom":12,"filter":["all",["==","$type","Point"],["==","class","state"]],"layout":{"visibility":"visible","text-field":"{name:latin}\n{name:nonlatin}","text-font":["Metropolis Regular","Noto Sans Regular"],"text-transform":"uppercase","text-size":10},"paint":{"text-color":"rgb(101,101,101)","text-halo-color":"rgba(0,0,0,0.7)","text-halo-width":1,"text-halo-blur":1}},{"id":"place_country_other","type":"symbol","metadata":{"mapbox:group":"101da9f13b64a08fa4b6ac1168e89e5f"},"source":"openmaptiles","source-layer":"place","maxzoom":8,"filter":["all",["==","$type","Point"],["==","class","country"],["!has","iso_a2"]],"layout":{"visibility":"visible","text-field":"{name:latin}","text-font":["Metropolis Light Italic","Noto Sans Italic"],"text-transform":"uppercase","text-size":{"base":1,"stops":[[0,9],[1,11]]}},"paint":{"text-halo-width":1.4,"text-halo-color":"rgba(0,0,0,0.7)","text-color":"rgb(101,101,101)"}},{"id":"place_country_minor","type":"symbol","metadata":{"mapbox:group":"101da9f13b64a08fa4b6ac1168e89e5f"},"source":"openmaptiles","source-layer":"place","maxzoom":8,"filter":["all",["==","$type","Point"],["==","class","country"],[">=","rank",2],["has","iso_a2"]],"layout":{"visibility":"visible","text-field":"{name:latin}","text-font":["Metropolis Regular","Noto Sans Regular"],"text-transform":"uppercase","text-size":{"base":1,"stops":[[0,10],[6,12]]}},"paint":{"text-halo-width":1.4,"text-halo-color":"rgba(0,0,0,0.7)","text-color":"rgb(101,101,101)"}},{"id":"place_country_major","type":"symbol","metadata":{"mapbox:group":"101da9f13b64a08fa4b6ac1168e89e5f"},"source":"openmaptiles","source-layer":"place","maxzoom":6,"filter":["all",["==","$type","Point"],["<=","rank",1],["==","class","country"],["has","iso_a2"]],"layout":{"visibility":"visible","text-field":"{name:latin}","text-font":["Metropolis Regular","Noto Sans Regular"],"text-transform":"uppercase","text-size":{"base":1.4,"stops":[[0,10],[3,12],[4,14]]},"text-anchor":"center"},"paint":{"text-halo-width":1.4,"text-halo-color":"rgba(0,0,0,0.7)","text-color":"rgb(101,101,101)"}}]},
          center: [this.mapSettings.lon, this.mapSettings.lat],
          zoom: this.mapSettings.zoom,
        });
        let _this = this
        this.map.on('load', function() {
          _this.getRadar()
          _this.addMetar()
        })
        setInterval(function() {
          let isLoading = !_this.map.loaded()
          _this.isLoading = isLoading
        }, 1000)
      },
      async getRadar() {
        const res = await this.$http.get('https://weather-tiling-api.wxdata.io/data/current/' + this.selectedProduct.id)
        if(this.radarScans.length == 0) {
          this.radarScans = res.data
          this.hasInitialLoaded = true
          this.loadRadarImagery(this.radarScans[this.radarScans.length - 1], 'visible')
          this.activeIndex = this.radarScans.length - 1
        }
      },
      loadRadarImagery(scan, visibility) {
        var source = [
          "https://a-tiles.wxdata.io/tileserver/" + scan.workspace + "/" + scan.identifier + "/{z}/{x}/{y}.png",
          "https://b-tiles.wxdata.io/tileserver/" + scan.workspace + "/" + scan.identifier + "/{z}/{x}/{y}.png",
          "https://c-tiles.wxdata.io/tileserver/" + scan.workspace + "/" + scan.identifier + "/{z}/{x}/{y}.png",
          "https://d-tiles.wxdata.io/tileserver/" + scan.workspace + "/" + scan.identifier + "/{z}/{x}/{y}.png",
        ]

        this.map.addLayer({
          'id': scan.identifier + '-radar',
          'type': 'raster',
          'source': {
            'type': 'raster',
            'tiles': source,
            'tileSize': 256,
          },
          'paint': {
            'raster-opacity': 0.6,
            "raster-fade-duration": 0
          },
          'layout': {
            'visibility': visibility,
          }
        }, 'railway');
      },
      playRadar() {
        // PRELOAD all of the layers first...
        var self = this
        this.radarScans.forEach(scan => {
          // console.log(scan.identifier + '-radar')
          if(typeof this.map.getLayer(scan.identifier + '-radar') == 'undefined') {
            this.loadRadarImagery(scan, 'none')
          } else {
            self.map.setLayoutProperty(scan.identifier + '-radar', 'visibility', 'none')
          }
        })

        // then play...
        this.isAnimating = true
        this.animateRadar()
      },
      pauseRadar() {
        this.isAnimating = false
        clearInterval(this.radarInterval)
        clearTimeout(this.radarIntervalHangTimeout)
        clearInterval(this.waitingForTilesToLoadInterval)
        this.radarInterval = null
        this.radarIntervalHangTimeout = null
        this.waitingForTilesToLoadInterval = null
      },
      animateRadar() {
        if(this.radarInterval !== null) {
          clearInterval(this.radarInterval)
          this.radarInterval = null
        }

        if(this.activeIndex == this.radarScans.length - 1) {
          this.activeIndex = 0
        }

        this.map.setLayoutProperty(this.radarScans[this.activeIndex].identifier + '-radar', 'visibility', 'visible')

        let self = this
        this.radarInterval = setInterval(function() {

          if(!self.map.loaded()) {
            clearInterval(self.radarInterval)
            self.waitingForTilesToLoadInterval = setInterval(function() {
                // console.log('waiting for tiles to load')
                if(self.map.loaded()) {
                  // console.log('tiles loaded... animate')
                  clearInterval(self.waitingForTilesToLoadInterval)
                  self.animateRadar()
                }
              }, 10)
          } else {
            self.activeIndex++;

            self.map.setLayoutProperty(self.radarScans[self.activeIndex].identifier + '-radar', 'visibility', 'visible')
            self.map.setLayoutProperty(self.radarScans[self.activeIndex - 1].identifier + '-radar', 'visibility', 'none')

            if(self.activeIndex == self.radarScans.length - 1) {
              clearInterval(self.radarInterval)
              self.radarIntervalHangTimeout = setTimeout(function() {
                self.map.setLayoutProperty(self.radarScans[self.activeIndex].identifier + '-radar', 'visibility', 'none')
                self.animateRadar()
              }, 1500)
            }
          }
        }, 250)
      },
      debounce(func, wait, immediate) {
        console.log('bouncer called')
        var timeout;

        return function executedFunction() {
          var context = this;
          var args = arguments;
            
          var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };

          var callNow = immediate && !timeout;
        
          clearTimeout(timeout);

          timeout = setTimeout(later, wait);
        
          if (callNow) func.apply(context, args);
        };
      },
      addMetar() {
        this.map.addSource('metar-source', {
          'type': 'geojson',
          'data': geojson
        })
        var barbCutoffs = [0,0,5,10,15,20,30,50,70];
        for (var b=0; b<barbCutoffs.length-1; b++){
            this.map.addLayer({
                'id':'barbs'+b,
                'type':'symbol',
                'filter':[
                    "all",
                    ['>=','windSpeed',barbCutoffs[b]/1.94384],
                    ['<', 'windSpeed',barbCutoffs[b+1]/1.94384]
                ],
                'source':'metar-source',
                'paint':{
                    'icon-opacity': 1,
                },
                'layout':{
                    'icon-image': (b == 0 || b == 1) ? 'calm' : barbCutoffs[b].toString(),
                    'icon-size': {
                      'base':1,
                      'stops': [
                        [2,0.1],
                        [6,0.5],
                        [8,0.7]
                      ]
                    },
                    'icon-anchor': 'center',
                    'icon-allow-overlap': true,
                    'icon-rotation-alignment': 'map',
                    'icon-rotate':{
                        'property':'windDirection',
                        'stops':[[0,90],[360,450]]
                    }
                },
            })
        }
        
        this.map.addLayer({
          'id': 'metar-temp',
          'type': 'symbol',
          'source': 'metar-source',
          'minzoom': 7,
          'layout': {
            'text-field': ['to-string', ['round', ['get', 'temperature']]],
            "text-font": [
              "DIN Offc Pro Medium",
              "Arial Unicode MS Bold"
            ],
            'text-size': 16,
            'text-offset': [-1.3, -0.75], // + right down, - left up
            'text-allow-overlap': true,
            'text-ignore-placement': false,
            'text-justify': 'right',
          },
          'paint': {
            'text-color': '#fff',
            'text-halo-color': '#000',
            'text-halo-width': 0.5,
            'text-halo-blur': 0
          }
        })
        this.map.addLayer({
          'id': 'metar-dew-pt',
          'type': 'symbol',
          'source': 'metar-source',
          'minzoom': 7,
          'layout': {
            'text-field': ['to-string', ['round', ['get', 'dewpoint']]],
            "text-font": [
              "DIN Offc Pro Medium",
              "Arial Unicode MS Bold"
            ],
            'text-size': 12,
            'text-offset': [-1.75, 0.75], // + right down, - left up
            'text-allow-overlap': true,
            'text-ignore-placement': false,
            'text-justify': 'right'
          },
          'paint': {
            'text-color': '#fff',
            'text-halo-color': '#000',
            'text-halo-width': 0.5,
            'text-halo-blur': 0
          }
        })
        this.map.addLayer({
          'id': 'metar-mslp',
          'type': 'symbol',
          'source': 'metar-source',
          'minzoom': 7,
          'layout': {
            'text-field': ['to-string', ['round', ['get', 'altimeter']]],
            "text-font": [
              "DIN Offc Pro Medium",
              "Arial Unicode MS Bold"
            ],
            'text-size': 12,
            'text-offset': [2, -0.95], // + right down, - left up
            'text-allow-overlap': true,
            'text-ignore-placement': false,
          },
          'paint': {
            'text-color': '#fff',
            'text-halo-color': '#000',
            'text-halo-width': 0.5,
            'text-halo-blur': 0
          }
        })
      },
      toggleSelector() {
        this.selectorExpanded = !this.selectorExpanded
      },
      async getAvailableSources() {
        const res = await this.$http.get('https://weather-tiling-api.wxdata.io/sources?type=mrms')
        this.availableProducts = res.data[0].products
      },
      async selectProduct(product) {
        this.toggleSelector()
        this.pauseRadar()
        this.selectedProduct = product
        console.log(this.selectedProduct)
        await this.removeRadarLayers()
        this.radarScans = []
        await this.getRadar()
      },
      async removeRadarLayers() {
        var self = this
        this.radarScans.forEach(scan => {
          if (self.map.getLayer(scan.identifier + '-radar')) {
            self.map.removeLayer(scan.identifier + '-radar');
          }
          if (self.map.getSource(scan.identifier + '-radar')) {
            self.map.removeSource(scan.identifier + '-radar');
          }
        })
      }
    },
    destroyed() {
      clearInterval(this.radarInterval)
    },
    filters: {
      formatToLocalTime: function(datetime) {
        return moment.utc(datetime).local().format('h:mm a');
      }
    }
  }
</script>

<style>
  html,body {
    margin: 0;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100vw;
    height: 100vh;
  }
  .mapboxgl-canvas {
    outline: none;
  }
  #map{
    width: 100vw;
    height: 100vh;
  }
</style>
